// extracted by mini-css-extract-plugin
export default {"hwaFooter":"HWAFooter_hwaFooter__WUAaC","horzList":"HWAFooter_horzList__YLz50"};